import React from 'react'
import { useStore } from '../../../../../lib/context';
import { observer } from 'mobx-react-lite';

const NavModuleActiveSearchFilters = observer(({activeFilters, removeFilter}) => {
    const {articleQueryStore: {activeTagsArray, updateActiveTags}} = useStore();
    return (
        <div className='active-search-filters'>
            <div 
                onClick={activeTagsArray[0] ? () => updateActiveTags(activeTagsArray[0]) : null}
                className={`active-filter flex--center ${!!activeTagsArray[0] ? 'active' : ''}`}>{activeTagsArray[0]}</div>
            <div 
                onClick={activeTagsArray[1] ? () => updateActiveTags(activeTagsArray[1]) : null}
                className={`active-filter flex--center ${!!activeTagsArray[1] ? 'active' : ''}`}>{activeTagsArray[1]}</div>
            <div 
                onClick={activeTagsArray[2] ? () => updateActiveTags(activeTagsArray[2]) : null}
                className={`active-filter flex--center ${!!activeTagsArray[2] ? 'active' : ''}`}>{activeTagsArray[2]}</div>

            <style jsx>{`
                .active-search-filters {
                    padding: 12px;
                    display: grid;
                    grid-template-columns: 1fr 1fr 1fr;
                    grid-gap: 6px;
                    border-radius: 30px;
                    background: rgba(230,230,230,.35);
                    margin: 28px 0 12px;
                }   

                .active-filter {
                    background: rgba(230,230,230,.65);
                    height: 32px;
                    border-radius: 20px;
                    cursor: pointer;
                    font-size: 14px;
                    transition: background .2s ease;
                }

                .active-filter.active {
                    background: white;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    .active-search-filters {
                        padding: 8px;
                    }
                    .active-filter {
                        font-size: 12px;
                        white-space: nowrap;
                        overflow: hidden;
                    }
                }

            `}</style>         
        </div>
    )
});



export default NavModuleActiveSearchFilters